import React from "react";
import { useTranslation } from "react-i18next";
//import Cookies from "js-cookie";
import "bootstrap/dist/css/bootstrap.min.css";
//import { DropdownButton, Dropdown, MenuItem } from "react-bootstrap";
import './LanguageSwitcher.css'

function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
   // Cookies.set('language', language, {expires: 30}); //cookes expire in 30 days.
   //i18next implements automatically if expiry not needed
  }
  return (
    
    <div className="select " >
    <label htmlFor="selectLanguage"><h5></h5></label>
      <select 
        //value={i18n.language}
        value={i18n.language}
        onChange={(e) =>
          changeLanguage(e.target.value)

        } className="custom-select my-select"
      >
        <option value="en">English</option>
        <option value="fr">Français</option>
        <option value="it">Italiano</option>
        {/* <option value="sp">Español</option>
        <option value="kr">Kirundi</option> */}
      </select>
    </div>
  );
}
export default LanguageSwitcher;